<template>
  <Layout height-full>
<!--    <div class="py-3">
      <div class="bg-success d-block d-md-none p-3 text-uppercase font-weight-bold">
        mobile on
      </div>
      <div class="bg-info text-white d-none d-md-block p-3 text-uppercase font-weight-bold">
        mobile off
      </div>
    </div>-->
    <div class="box">
      <check-in-header :on-filter="filter => applyFilter(filter)"/>
      <index-list ref="list" class="box-list"/>
    </div>
    <index-footer/>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import IndexFooter from '@/modules/check-in/pages/index/index-footer'
import IndexList from '@/modules/check-in/pages/index/index-list'
import CheckInHeader from '@/modules/check-in/pages/index/check-in-header'

export default {
  name: 'index',
  components: {
    IndexList,
    IndexFooter,
    CheckInHeader,
    Layout
  },
  page: {
    title: 'Check-In'
  },
  mounted () {
    // Scroll personalizado da plataforma (fino, cinza) só nesta tela.
    document.documentElement.classList.add('checkin-scroll')
    document.body.classList.add('checkin-scroll')
  },
  beforeDestroy () {
    document.documentElement.classList.remove('checkin-scroll')
    document.body.classList.remove('checkin-scroll')
  },
  methods: {
    applyFilter (filter) {
      this.$refs.list.filter(filter.search ?? null, filter.onlyWaiting ?? null, filter.onlyCheckIn ?? null)
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  min-height: 100%;
  // display: grid;
  grid-auto-rows: min-content auto;
  .box-filter {
    margin-bottom: 24px;
  }
}
</style>

<!-- Scrollbar personalizada (igual à do menu lateral) aplicada ao container que
     REALMENTE rola nesta tela: o .main-content do layout (a janela não rola —
     #layout-wrapper é 100vh/overflow:hidden). A classe fica no body só enquanto a
     tela de check-in está ativa, então não vaza pra outras telas. -->
<style lang="scss">
body.checkin-scroll .main-content {
  scrollbar-width: thin;
  scrollbar-color: #a2adb7 transparent;
}

body.checkin-scroll .main-content::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

body.checkin-scroll .main-content::-webkit-scrollbar-track {
  background: transparent;
}

body.checkin-scroll .main-content::-webkit-scrollbar-thumb {
  background: #a2adb7;
  border-radius: 7px;
}
</style>
